export enum CardTypes {
  Villager = "Villager",
  Week = "Week",
  Clan = "Clan",
  Quest = "Quest",
  Adventurer = "Adventurer",
}
